import { useQuery } from '@tanstack/react-query';
import { Search } from '@domain/insights/models/Search';
import { container } from '@infrastructure/container';

export const useSearchTerm = (searchTerm?: string) => {
  const {
    data: searchTermData,
    isLoading: isLoadingSearchTerm,
    error: searchTermError
  } = useQuery<Search>({
    queryKey: ['searchTerm', searchTerm],
    queryFn: async () => {
      if (!searchTerm) throw new Error('Search term is required');
      const result = await container.insightsRepository.getSearchTerm(searchTerm);
      if (result.status === 'error') throw new Error(result.error.message);
      return result.data;
    },
    enabled: !!searchTerm,
    refetchOnWindowFocus: false,
    staleTime: 0,
    refetchOnMount: true,
  });

  return {
    searchTerm: searchTermData,
    isLoading: isLoadingSearchTerm,
    error: searchTermError
  };
};

